import { STAFF_EMAILS } from "../config/constants";

/**
 * Resolve a Firebase Auth email to a staff display name.
 */
export const getStaffName = (email) =>
  STAFF_EMAILS[(email || "").toLowerCase()] ||
  (email || "").split("@")[0] ||
  "Unknown";

/**
 * Auto-detect default tax year:
 * before Oct 18 → prior year, Oct 18+ → current year.
 */
export const getDefaultTaxYear = () => {
  const now = new Date();
  const year = now.getFullYear();
  const isPriorYear =
    now.getMonth() < 9 || (now.getMonth() === 9 && now.getDate() <= 18);
  return String(isPriorYear ? year - 1 : year);
};

/**
 * Format a phone number string to (XXX)XXX-XXXX.
 */
export const formatPhone = (p) => {
  if (!p) return "";
  const d = p.replace(/\D/g, "");
  if (d.length === 10)
    return `(${d.slice(0, 3)})${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d[0] === "1")
    return `(${d.slice(1, 4)})${d.slice(4, 7)}-${d.slice(7)}`;
  return p;
};

/**
 * Module-level counter for stable React keys on new business objects.
 * NEVER use Date.now() — causes wrong Firestore IDs.
 */
let _bizKeyCounter = 0;

export const emptyBiz = () => ({
  _key: ++_bizKeyCounter,
  legalName: "",
  ein: "",
  entityType: "LLC",
  industry: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  yearFounded: "",
  isPrimary: false,
  isBookkeeping: false,
});
